const featuresData = [
  {
    icon: 'ri-stack-line',
    title: '多平台聚合',
    desc: '整合香蕉视频、红桃视频、91视频、蜜桃视频等超过15家热门影视平台，一个入口即可浏览全部平台信息，无需逐个搜索。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '实时排行更新',
    desc: '基于用户访问热度、内容更新频率、播放体验与社区口碑的综合算法，每日自动更新热门排行，帮助您快速锁定优质平台。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '客观中立推荐',
    desc: '所有平台信息与排名均以数据为基础，不偏袒任何单一平台。我们坚持客观公正的推荐原则，让数据说话。',
  },
  {
    icon: 'ri-speed-mini-line',
    title: '极速访问体验',
    desc: '页面设计轻量化，加载速度极快。所有内容均为静态展示，无需注册登录即可完整浏览，真正做到即开即用。',
  },
];

export default function Features() {
  return (
    <section id="features" className="bg-background-50 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            青青草视频以用户体验为核心，四大优势让影视平台发现变得更简单
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((feature, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-6 hover:border-primary-200 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2.5">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}